import { Skeleton } from '@inflearn/ds-react';
import { Stack } from '@mantine/core';
import { range } from 'lodash-es';

interface SectionSkeletonProps {
  lines: number;
}

export const SectionSkeleton = ({ lines }: SectionSkeletonProps) => {
  return (
    <Stack spacing={8}>
      {range(lines).map((line) => (
        <Skeleton key={line} w="100%" h={20} radius="md" />
      ))}
    </Stack>
  );
};
